import { Component, OnInit } from '@angular/core';
import { Committes } from '../../models/committes';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { CommittesService } from '../../services/committes-service';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';

@Component({
  selector: 'app-get-committe-details',
  templateUrl: './get-committe-details.component.html',
  styleUrls: ['./get-committe-details.component.scss']
})
export class GetCommitteDetailsComponent implements OnInit {


  model = {} as Committes;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetCommitteDetailsComponent>,
    public sanitizer: DomSanitizer,
    private service : CommittesService
  ) { }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });

  }
    downloadFile(fileName) {
      this.service.downloadFile(fileName).subscribe((blob) => {
        downloadFileUtil(blob, fileName);
      });
    }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

}
